// require('./error_handler')

// import 'babel-polyfill'


window._ = require('lodash');
window.Popper = require('popper.js').default;

// Require polyfills
// TODO: extract these to separate file and pull in for ie11 only
require('./polyfills/dom4.js')
require('./polyfills/array_includes')
require('./polyfills/string.includes');
require('./polyfills/object.values');
require('es6-promise').polyfill();

// Require fontawesome icons (there's nothing awesome about it)
require('./fontawesome-all.js')

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    // if (!window.$ && !window.jQuery) {
        window.$ = window.jQuery = require('jquery');
    // }

    require('bootstrap');
} catch (e) {}


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
require('./bootstrap_axios');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });